'use client';
import { useOrder, usePractice } from '@witmetrics/data-store';
import { formatOrderName } from '@witmetrics/utils/orders';
import { useAppState } from '@/providers/AppStateProvider';
import Tooltip from '@/components/Tooltip';
import OrderStatus from '@/components/OrderStatus';
import { MenuIcon } from '@/icons';
import { classes, styles } from './utils';

export type OrderHeaderProps = {
  collapsed: boolean;
  onToggleCollapsed: () => void;
};

export default function LeadHeader({
  collapsed,
  onToggleCollapsed,
}: OrderHeaderProps) {
  const { activeOrderId } = useAppState();
  const order = useOrder(activeOrderId);
  const practice = usePractice(order?.practiceId);

  const renderCollapseToggle = () => {
    return (
      <Tooltip title={collapsed ? 'Show timeline' : 'Hide timeline'}>
        <MenuIcon
          style={styles.collapseIcon(collapsed)}
          className={classes.icon}
          onClick={onToggleCollapsed}
        />
      </Tooltip>
    );
  };

  if (!order || !practice) return null;

  if (collapsed) {
    return <div className={classes.wrapper}>{renderCollapseToggle()}</div>;
  }

  return (
    <div className={classes.wrapper}>
      {renderCollapseToggle()}
      <div className={classes.textWrapper}>
        <h1 className={classes.orderId}>{formatOrderName(order)}</h1>
        <h2 className={classes.customer}>{practice.name}</h2>
        <div className={classes.statusWrapper}>
          <OrderStatus order={order} />
        </div>
      </div>
    </div>
  );
}
